<!--人才招聘-->
<template>
  <el-row class="hei100 flex-column">
    <div id="topbar" class=" bgc-blue2">
      <el-row>
        <el-col :span="9">
          <img class="fl" src="../../assets/images/logo2.png" style="height:60px;">
        </el-col>
        <el-col :span="15">
          <el-row class="menu" type="flex">
            <div class="text-right flexson " @click="openUrl(1)">
              <a href="#part1"><span>首页</span></a>
            </div>
            <div class="text-right flexson" @click="openUrl(2)">
              <a href="#part2"><span>软件业务</span></a>
            </div>
            <div class="text-right flexson" @click="openUrl(3)">
              <a href="#part3"><span>企业简介</span></a>
            </div>
            <div class="text-right flexson" @click="openUrl(4)">
              <a href="#part4"><span>企业优势</span></a>
            </div>
            <div class="text-right flexson onclick" @click="openUrl(5)">
              <a href="#part5"><span>新闻资讯</span></a>
            </div>
            <div class="text-right flexson" @click="dialogVisible = true">
              <a href="#part6"><span>联系我们</span></a>
            </div>
            <div class="text-right flexson " @click="openUrlJoin()">
              <span>人才招聘</span>
            </div>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <!--  -->
    <el-row class=" ">
      <div class="bgc-blue2" style="padding-top:140px; padding-bottom:20px;">
        <img class="block auto" src="../../assets/part2/news-title.png" alt="">
      </div>
      <template v-for="(item,index) in list">
        <el-row :key="index" class="auto mar-top20" type="flex" style="width:1320px;">
          <el-row class="news-left">
            <img class="fl" :src="item.imgurl" alt="">
            <div class="fr">
              <el-row class="text-right height70">
                <span class="ft-size42 fc-blue bold">{{item.mouth}}/{{item.date}}</span>
              </el-row>
              <el-row class=" text-right height40">
                <span class="ft-size26 fc-blue bold">{{item.year}}</span>
              </el-row>
              <el-row class=" text-right">
                <span class="width100 inline-block hei30 bgc-blue2 fc-wt ft-size18 text-center">{{item.type}}</span>
              </el-row>
            </div>
          </el-row>
          <div class="flex-son" style="padding-top:28px;padding-left:38px;">
            <div class="bold fc-2 ft-size24 text-justify">{{item.newstit}}</div>
            <div class="lineh30 pading20 text-justify">
              <span
                class="ft-size18 fc-6" v-html="item.newscont"></span>
            </div>
            <div class="text-right">
              <span class="ft-size18 fc-blue pointer lookmore" @click="openUDetail(index)">查看详情</span>
            </div>
          </div>
        </el-row>
        <el-divider :key="index"></el-divider>
      </template>
      <el-row class=" text-center pad20">
        <!-- <el-pagination @current-change="currPage" background :page-size="5" layout="prev, pager, next" :total="total">
        </el-pagination> -->
      </el-row>
    </el-row>
    <footerbar></footerbar>
    <el-dialog title="" :visible.sync="dialogVisible" class="newdialog" width="790px" append-to-body>
      <div>
        <el-row style="padding-left:40px;padding-bottom:30px;">
          <img class="fl" src="@/assets/images/logo1.png" style="height:40px;">
        </el-row>
        <el-row>
          <el-col :span="17" style="padding-left:40px;">
            <el-row class="hei40">
              <span class="fc-2 ft-size16">地&emsp;&emsp;址:</span>
              <span class="fc-2 ft-size16">北京市昌平区北清路1号院8号楼14层</span>
            </el-row>
            <el-row class="hei40">
              <span class="fc-2 ft-size16">邮&emsp;&emsp;箱:</span>
              <span class="fc-2 ft-size16 ">155396138@qq.com&emsp;2627504375@qq.com</span>
            </el-row>            
            <el-row class="hei40">
              <span class="fc-2 ft-size16">商务合作:</span>
              <span class="fc-2 ft-size16 pointer">15869194531(乐)</span>
            </el-row>
            <el-row class="hei40">
              <span class="fc-2 ft-size16">网&emsp;&emsp;站:</span>
              <span class="fc-2 ft-size16 pointer">http://www.ylybj.cn</span>
            </el-row>
          </el-col>
          <el-col :span="7">
            <div style=" margin-left:40px; border-left:1px solid #ddd; height:200px;" class=" algincenter">
              <div>
                <el-row class="border">
                  <img class="width100 block" src="@/assets/icon/qrcode.png" alt="">
                </el-row>
                <el-row class="text-center hei30">
                  <span class="fc-2 ft-size16">微信公众号</span>
                </el-row>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </el-row>
</template>

<script>
import footerbar from "../footerbar";
export default {
  name: "newsList",
  components: { footerbar },
  data() {
    return {
      dialogVisible:false,
      total: 30,
      pageindex: 1,
      list: [
        {
          newstit: "【资讯】加大农村公路养护力度，北京累计投入养护资金182亿",
          newscont:
            "　　十月京郊，秋意正浓，踏上北京市房山区新泗路，人来车往，沿途一派热闹喧腾的景象。沿路而行，红色背篓精神薪火相传，坡峰岭层林尽染令人流连忘返...<br>　　据北京市交通委消息，新泗路于近日成功入选2022年北京市“最美乡村路”，它串联起红色文化、自然生态、人文景观等丰富的旅游资源，有效带动了当地经济发展。",
          year:'2022',
          mouth:'10',
          date:'31',
          type:'行业动态',
          imgurl:require('@/assets/news/news1.png')
        },
        {
          newstit: "【行业】一键打通“智能中枢”，公路养护信息化未来已来",
          newscont:
            "　　目前我国公路总里程已达528万公里,形成了以高速公路为骨架、普通干线为脉络、农村公路为基础的全国公路网。<br> 　　公路交通是覆盖范围最广、服务人口最多、使用最广泛的交通运输方式，维护好这些规模庞大的公路资产，加强公路养护管理工作意义重大。而公路养护的信息化、智慧化...",
          year:'2022',
          mouth:'10',
          date:'28',
          type:'行业动态',
          imgurl:require('../../assets/news/news2.png')
        },
        {
          newstit: "数字化·网络化·智慧化 |  “养路云”智慧养护，亮相第24届中国高速公路信息化大会",
          newscont:
            "　　7月27日-28日，由中国公路学会主办的第二十四届中国高速公路信息化大会在长沙举行。秀川科技携“养路云”下多项公路信息化领域研发成果惊艳亮相。<br> 　　大会期间，中国公路学会理事、原交通运输部副部长翁孟勇及交通部各领导、行业专家于产品展示区参观指导。",
          year:'2022',
          mouth:'07',
          date:'28',
          type:'企业要闻',
          imgurl:require('@/assets/news/news3.png')
        },
        {
          newstit: "宜春市公路事业发展中心大力推荐使用“养路云”路面养护科学决策系统",
          newscont:
            "　　近日，宜春市公路事业发展中心在使用“养路云”路面养护科学决策系统的过程中，发现软件的显示数据与实际情况吻合度极高，随即在6月8-10日，邀请北京养路云员工，前往宜春市对系统的使用做深度培训，在系统的实际使用过程中获得宜春市公路事业发展中心高度重视，并取得各管养人员一致好评，大力推荐广大公路管养部门使用！",
          year:'2022',
          mouth:'07',
          date:'12',
          type:'企业要闻',
          imgurl:require('@/assets/news/news4.png')
        },
        {
          newstit: "同心抗疫，志愿守护——北京养路云化身“防疫守护者”",
          newscont:
            "　　3、4月的英雄城，疫情汹涌而来，面对南昌的抗疫形势严峻，所有人都自发的团结起来，北京养路云作为“公路守护者”的一员，在这个时刻毫不犹豫化身“防疫守护者”，支援一线，为疫情防护做出贡献。",
          year:'2022',
          mouth:'04',
          date:'14',
          type:'企业要闻',
          imgurl:require('@/assets/news/news5.png')
        }
      ]
    };
  },
  mounted() {
    document.body.scrollTop = 0;
    // let scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
    // scrollTop=0;
  },
  methods: {
    openUrl(n) {
      this.$router.push({ path: "/index" });
    },
    openUrlJoin() {
      this.$router.push({ path: "/joinUs" });
    },
    currPage(index) {
      this.pageindex = index;
      console.log(this.pageindex);
    },
    openUDetail(idx) {
      if(idx>3){return;}
      document.documentElement.scrollTop = 0;

      this.$router.push({ path: "/newsCont",query:{index:idx} });
    }
  },
  destroyed() {},
  watch: {}
};
</script>



// WEBPACK FOOTER //
// src/components/basicData/newsList.vue